<template>
  <div class="wrapper" :class="{ 'nav-open': $sidebar.showSidebar }">
    <side-bar>
      <template v-slot:links>
        <user-menu></user-menu>
        <!-- <sidebar-item
          :link="{
            name: 'Dashboard',
            icon: 'now-ui-icons design_app',
            path: '/dashboard',
          }"
        >
        </sidebar-item> -->
        <sidebar-item
          :link="{
            name: 'เติมเกม',
            icon: 'now-ui-icons tech_controller-modern',
            path: '/game',
          }"
        >
        </sidebar-item>
        <sidebar-item
          v-if="uid !== ''"
          :link="{
            name: 'ประวัติการสั่งซื้อ',
            icon: 'now-ui-icons business_money-coins',
            path: '/purchase/history',
          }"
        >
        </sidebar-item>
        <sidebar-item
          v-if="role === 'agent' || admin"
          :link="{
            name: 'My Wallet',
            icon: 'now-ui-icons business_money-coins',
            path: '/wallet',
          }"
        >
        </sidebar-item>
        <sidebar-item
          v-if="uid !== '' && admin"
          :link="{ name: 'ตั้งค่า', icon: 'now-ui-icons loader_gear' }"
        >
          <sidebar-item
            v-if="manager"
            :link="{ name: 'จัดการเกม', path: '/management/game' }"
          ></sidebar-item>
          <sidebar-item
            v-if="manager"
            :link="{ name: 'จัดการผู้ใช้', path: '/management/user' }"
          ></sidebar-item>
          <sidebar-item
            :link="{ name: 'จัดการใบสั่งซื้อ', path: '/management/history' }"
          ></sidebar-item>
          <sidebar-item
            v-if="manager"
            :link="{ name: 'จัดการ Agent', path: '/management/agent' }"
          ></sidebar-item>
          <sidebar-item
            v-if="manager"
            :link="{ name: 'จัดการรายการ Wallet', path: '/management/wallet' }"
          ></sidebar-item>
          <sidebar-item
            v-if="manager"
            :link="{
              name: 'Benefit Agent - เติมเกม',
              path: '/management/benefitgametopup',
            }"
          ></sidebar-item>
          <sidebar-item
            v-if="manager"
            :link="{
              name: 'Bank Statement',
              path: '/management/bankstatement',
            }"
          ></sidebar-item>
          <sidebar-item
            v-if="manager"
            :link="{ name: 'App Config', path: '/management/appconfig' }"
          ></sidebar-item>
        </sidebar-item>
        <sidebar-item
          v-if="uid !== '' && manager"
          :link="{ name: 'Report', icon: 'now-ui-icons education_paper' }"
        >
          <sidebar-item
            :link="{ name: 'Sales Dashboard', path: '/dashboard/sale' }"
          ></sidebar-item>
          <sidebar-item
            :link="{ name: 'Stock Dashboard', path: '/dashboard/stock' }"
          ></sidebar-item>
        </sidebar-item>
        <!-- <sidebar-item
          :link="{ name: 'Pages', icon: 'now-ui-icons design_image' }"
        >
          <sidebar-item
            :link="{ name: 'Pricing', path: '/pricing' }"
          ></sidebar-item>
          <sidebar-item
            :link="{ name: 'Timeline', path: '/pages/timeline' }"
          ></sidebar-item>
          <sidebar-item
            :link="{ name: 'Login', path: '/login' }"
          ></sidebar-item>
          <sidebar-item
            :link="{ name: 'Register', path: '/register' }"
          ></sidebar-item>
          <sidebar-item
            :link="{ name: 'Lock Screen', path: '/lock' }"
          ></sidebar-item>
          <sidebar-item
            :link="{ name: 'User Profile', path: '/pages/user' }"
          ></sidebar-item>
        </sidebar-item>
        <sidebar-item
          :link="{ name: 'Components', icon: 'now-ui-icons education_atom' }"
        >
          <sidebar-item
            :link="{ name: 'Buttons', path: '/components/buttons' }"
          ></sidebar-item>
          <sidebar-item
            :link="{ name: 'Grid System', path: '/components/grid-system' }"
          ></sidebar-item>
          <sidebar-item
            :link="{ name: 'Panels', path: '/components/panels' }"
          ></sidebar-item>
          <sidebar-item
            :link="{ name: 'Sweet Alert', path: '/components/sweet-alert' }"
          ></sidebar-item>
          <sidebar-item
            :link="{ name: 'Notifications', path: '/components/notifications' }"
          ></sidebar-item>
          <sidebar-item
            :link="{ name: 'Icons', path: '/components/icons' }"
          ></sidebar-item>
          <sidebar-item
            :link="{ name: 'Typography', path: '/components/typography' }"
          ></sidebar-item>
        </sidebar-item>
        <sidebar-item
          :link="{ name: 'Forms', icon: 'now-ui-icons files_single-copy-04' }"
        >
          <sidebar-item
            :link="{ name: 'Regular Forms', path: '/forms/regular' }"
          ></sidebar-item>
          <sidebar-item
            :link="{ name: 'Extended Forms', path: '/forms/extended' }"
          ></sidebar-item>
          <sidebar-item
            :link="{ name: 'Validation Forms', path: '/forms/validation' }"
          ></sidebar-item>
          <sidebar-item
            :link="{ name: 'Wizard', path: '/forms/wizard' }"
          ></sidebar-item>
        </sidebar-item>

        <sidebar-item
          :link="{ name: 'Tables', icon: 'now-ui-icons design_bullet-list-67' }"
        >
          <sidebar-item
            :link="{ name: 'Regular Tables', path: '/table-list/regular' }"
          ></sidebar-item>
          <sidebar-item
            :link="{ name: 'Extended Tables', path: '/table-list/extended' }"
          ></sidebar-item>
          <sidebar-item
            :link="{ name: 'Paginated Tables', path: '/table-list/paginated' }"
          ></sidebar-item>
        </sidebar-item>
        <sidebar-item
          :link="{ name: 'Maps', icon: 'now-ui-icons location_pin' }"
        >
          <sidebar-item
            :link="{ name: 'Google Maps', path: '/maps/google' }"
          ></sidebar-item>
          <sidebar-item
            :link="{ name: 'Full Screen Maps', path: '/maps/full-screen' }"
          ></sidebar-item>
          <sidebar-item
            :link="{ name: 'Vector Maps', path: '/maps/vector-map' }"
          ></sidebar-item>
        </sidebar-item>
        <sidebar-item
          :link="{
            name: 'Widgets',
            icon: 'now-ui-icons objects_diamond',
            path: '/widgets',
          }"
        ></sidebar-item>
        <sidebar-item
          :link="{
            name: 'Charts',
            icon: 'now-ui-icons business_chart-pie-36',
            path: '/charts',
          }"
        ></sidebar-item>
        <sidebar-item
          :link="{
            name: 'Calendar',
            icon: 'now-ui-icons media-1_album',
            path: '/calendar',
          }"
        ></sidebar-item> -->
      </template>
    </side-bar>
    <div class="main-panel">
      <top-navbar></top-navbar>
      <router-view name="header"></router-view>

      <div
        :class="{ content: !$route.meta.hideContent }"
        @click="toggleSidebar"
      >
        <router-view></router-view>
      </div>
      <content-footer v-if="!$route.meta.hideFooter"></content-footer>
    </div>
  </div>
</template>
<script>
/* eslint-disable no-new */
// import PerfectScrollbar from "perfect-scrollbar";
// import "perfect-scrollbar/css/perfect-scrollbar.css";

// function hasElement(className) {
//   return document.getElementsByClassName(className).length > 0;
// }
//
// function initScrollbar(className) {
//   if (hasElement(className)) {
//     new PerfectScrollbar(`.${className}`);
//   } else {
//     // try to init it later in case this component is loaded async
//     setTimeout(() => {
//       initScrollbar(className);
//     }, 100);
//   }
// }

import TopNavbar from "./TopNavbar.vue";
import ContentFooter from "./ContentFooter.vue";
import UserMenu from "./extra/UserMenu.vue";
import firebase from "firebase";

export default {
  components: {
    TopNavbar,
    ContentFooter,
    UserMenu,
  },
  data() {
    return {
      uid: "",
      role: "customer",
      admin: false,
      manager: false,
      staff: false,
    };
  },
  methods: {
    toggleSidebar() {
      if (this.$sidebar.showSidebar) {
        this.$sidebar.displaySidebar(false);
      }
    },
  },
  beforeCreate() {
    let currentUser = firebase.auth().currentUser;
    if (currentUser) {
      this.uid = currentUser.uid;
      firebase
        .auth()
        .currentUser.getIdTokenResult()
        .then((result) => {
          this.role = result.claims?.role || this.role;
          this.admin =
            this.role === "admin" ||
            this.role === "manager" ||
            this.role === "staff";
          this.manager = this.role === "admin" || this.role === "manager";
          this.staff = this.role === "staff";
        });
    } else {
      let authListenerUnsuscribe = firebase
        .auth()
        .onAuthStateChanged((user) => {
          if (user) {
            this.uid = user.uid;
            firebase
              .auth()
              .currentUser.getIdTokenResult()
              .then((result) => {
                this.role = result.claims?.role || this.role;
                this.admin =
                  this.role === "admin" ||
                  this.role === "manager" ||
                  this.role === "staff";
                this.manager = this.role === "admin" || this.role === "manager";
                this.staff = this.role === "staff";
              });
            authListenerUnsuscribe();
          }
        });
    }
  },
};
</script>
<style lang="scss">
.sidebar .nav li > a,
.off-canvas-sidebar .nav li > a {
  font-size: 1em !important;
  text-transform: none !important;
}
</style>
